<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				headDataII:getdata().headDataII
			};
		},
		props: {
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
			tableDataII:{
				type: Array,
				default: [],
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		methods: {
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			spanmethods({
				row,
				column,
				rowIndex,
				columnIndex
			}){
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 17){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 24){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 28){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 1){
					if(rowIndex === 0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 17){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 24){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if(rowIndex === 28){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 2){
					if(rowIndex === 0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 17){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 24){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if(rowIndex === 28){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 3){
					if(rowIndex === 0){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if(rowIndex === 17){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if(rowIndex === 24){
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else if(rowIndex === 28){
						return {
							rowspan: 0,
							colspan: 0
						};
					} else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 15){
						return {
							rowspan: 1,
							colspan: 4
						};
					}else if(rowIndex === 19){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 29){
						return {
							rowspan: 1,
							colspan: 4
						};
					}else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 1){
					if(rowIndex === 0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 15){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 19){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 29){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 2){
					if(rowIndex === 0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 15){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 19){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 29){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
